export { default as MACPComponentConditions } from './MACPComponentConditions.component';
